import { Menu } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { navSections } from "./nav-config";
import { cn } from "@/lib/utils";

export function MobileNav() {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Open menu" className="md:hidden">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-72 p-0 pt-12">
        <div className="px-5 pb-4">
          <SheetTitle className="text-md">OpenClaw Sales</SheetTitle>
          <SheetDescription>Sales control room</SheetDescription>
        </div>
        <nav className="px-3 pb-6">
          {navSections.map((section) => (
            <div key={section.label} className="mb-5">
              <div className="px-2 pb-1.5 text-xs font-medium uppercase tracking-wider text-ink-faint">
                {section.label}
              </div>
              <ul className="flex flex-col gap-0.5">
                {section.items.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.to === "/"}
                      onClick={() => setOpen(false)}
                      className={({ isActive }) =>
                        cn(
                          "flex items-center gap-2.5 rounded-md px-2 py-1.5 text-sm transition-colors",
                          isActive
                            ? "bg-accent-soft text-accent-strong font-medium"
                            : "text-ink-muted hover:bg-surface-muted hover:text-ink"
                        )
                      }
                    >
                      <item.icon className="h-4 w-4" strokeWidth={1.75} />
                      <span>{item.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
